import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCanManagePortalUsers } from '../../hooks';
import { configurationPaths } from '../../util/constants';
import { RolePermissionsReference } from './components/RolePermissionsReference';

export const PortalUserRoles = () => {
  const { isLoading: merchantInfoLoading } = useMerchant();
  const canManagePortalUsers = useCanManagePortalUsers();

  if (!canManagePortalUsers) {
    return <Navigate to={configurationPaths.SETTINGS} replace />;
  }

  return (
    <PageWrapper
      data-testid="PORTAL_USER_ROLES"
      title="Roles & permissions"
      description="Plain-language summary of portal roles you can assign."
      isLoading={merchantInfoLoading}
      sx={{ width: '100%' }}
    >
      <Box>
        <RolePermissionsReference />
      </Box>
    </PageWrapper>
  );
};
